import { Component, OnInit, ElementRef, ViewEncapsulation, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddShippingRQ, DeleteShippingRQ, ShippingListModel, ShippingListExportModel, ShippingService, UpdateShippingRQ } from 'app/open-api';
import { CreateShippingModalComponent } from 'app/shared/components/create-shipping-modal/create-shipping-modal.component';
import { SearchShipmentsComponent } from './../../shared/components/search-shipments/search-shipments.component';
import { ShippingExpensesModalComponent } from 'app/shared/components/shipping-expenses-modal/shipping-expenses-modal.component';
import { ShippingFlightModalComponent } from 'app/shared/components/shipping-flight-modal/shipping-flight-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ShippingType, shippingTypes } from '../../open-api/model/shippingType';
import { AuthService } from '../../authentication/services/auth.service';
import Swal from 'sweetalert2';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ShippingListRQ, ListShippingWithBillsRQ, ListShippingWithBillsRP, ShippingModelWithBillModel, BillSummaryShipmentDto } from '../../open-api/model/ShippingListRQ';
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe, CurrencyPipe } from '@angular/common';
import * as XLSX from 'xlsx';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { PageEvent, MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { SearchShipmentRQ } from './../../open-api/model/SearchShipmentRQ';
import {CustomerAssignLocalModel} from '../../shared/models/assigment-local.model';
import { debounceTime } from 'rxjs/operators';


@Component({
  selector: "app-shipping",
  templateUrl: "./shipping.component.html",
  styleUrls: ["./shipping.component.scss"],
  providers: [DatePipe, CurrencyPipe],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class ShippingComponent implements OnInit {
  @ViewChild("popOver") public popover: NgbPopover;
  @ViewChild("myModal") private _myModal: ElementRef;
  @ViewChild("searchInput") searchInput!: ElementRef;
  public basicSelectedOption: number = 5;
  public shippings: ShippingListModel[] = [];
  public allShippings: ShippingListModel[] = [];
  public ColumnMode = ColumnMode;
  public minDate = new Date("0001-01-01T00:00:00").getTime();
  searchFrm: FormGroup;
  shippingTypes: Array<ShippingType> = [];
  shippingBillsShow: Array<ShippingShow> = [];
  dataSource: MatTableDataSource<ShippingShow>;
  isAdmin = false;
  @ViewChild("outerSort", { static: true }) sort: MatSort;
  @ViewChildren("innerSort") innerSort: QueryList<MatSort>;
  @ViewChildren("subSort") subSort: QueryList<MatSort>;
  @ViewChildren("innerTables") innerTables: QueryList<
    MatTable<BillSummaryShow>
  >;
  @ViewChildren("subTables") subTables: QueryList<MatTable<Block>>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  dataSource1: MatTableDataSource<User>;
  usersData: User[] = [];
  columnsToDisplay = [
    "code",
    "type",
    "desciption",
    "created",
    "cost",
    "state",
    "actions",
  ];
  innerDisplayedColumns = [
    "code",
    "pounds",
    "province",
    "municipality",
    "state",
    "actions",
  ];
  subBlockDisplayedColumns = ["name", "level", "unitnumber"];
  expandedElement: ShippingShow | null;
  expandedSubElement: BillSummaryShow | null;
  //filteredValues: EmpFilter[]=[];
  //this.filteredValues
  length = 50;
  pageSize = 5;
  pageIndex = 0;
  totalRecords = 0;
  pageSizeOptions = [5, 10, 15];
  filter: SearchShipmentRQ;
  searching = false;

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  pageEvent: PageEvent;
  searchText: string = '';  

  constructor(
    private cd: ChangeDetectorRef,
    private shippingService: ShippingService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe,
    private _authenticationService: AuthService
  ) {
    this.shippingTypes = shippingTypes;
    this.searchFrm = new FormGroup({
      text: new FormControl(""),
    });

    
  }

  async ngOnInit(): Promise<void> {
    this.searchFrm.valueChanges
      .pipe(debounceTime(500)) 
      .subscribe((value) => {
        this.searchText = value;        
        this.applyFilter(this.searchText);
      });

    this.checkIsAdmin();
    await this.FetchModels();
  }

  handlePageEvent(e: PageEvent) {
    //console.log(e)
    this.spinner.show();
    let search = { ...this.filter };
    search.pageSize = e.pageSize;
    search.pageNumber = e.pageIndex + 1;
    //console.log(search)
    //const search = {...this.filter, pageSize, pageSize;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex + 1;
    this.searching = true;
    this.shippingService
      .apiShippingListWithBillsGet(search)
      .subscribe((response) => {
        //this.allShippings = this.shippings = this.ModelParse(response.list);
        //this.totalRecords = response.totalRecords;
        this.transformResponse(response.list);
        this.spinner.hide();
        this.searching = false;
      });
    /*this.service.search(search).subscribe({
      next: ((results) => {
        this.totalRecords = results?.length ? results[0].totalRecords : 0;
        this.dataSource.data = results || [];
      }),
      complete: () => this.searching = false,
      error: () => this.searching = false,
    });*/
    //console.log(this.totalRecords)
    //this.pageEvent = e;
    //const pageSize = +event.pageSize; // get the pageSize
    // const currentPage = +event.pageIndex + 1; // get the current page
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(",")
        .map((str) => +str);
    }
  }

  truncText(text: string) {
    if (text?.length > 54) {
      return text.slice(0, 51) + "... \n" + text.slice(51, text?.length);
    }
    return text;
  }

  generateBillLabelsPDF(element) {
    this.spinner.show();
    const cardWidth = 15 * 72;
    const cardHeight = 10 * 72;
    const margin = 5;
    const content = [];
    
    element.shipingType == 1
      ? content.push(
          {
            columns: [
              {
                text: element.billCode,
                fontSize: 90,
                bold: true,
                alignment: "right",
                margin: [180, 10, 0, 10],
              },
              {
                qr: element.billCode, // Data to encode in the QR code
                fit: 100, // Size of the QR code
                fontSize: 20,
                bold: true,
                alignment: "left",
                margin: [15, 10, 65, 10],
              },
            ],
          },
          {
            columns: [
              {
                text: element.province,
                fontSize: 80,
                alignment: "center",
                margin: [0, 2, 70, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: element.municipality,
                fontSize: 60,
                alignment: "center",
                margin: [0, 2, 10, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: "Destinatario: " + element.customer.Name,
                fontSize: 40,
                alignment: "left",
                margin: [0, 2, 20, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: element.customer.Address,
                fontSize: 25,
                alignment: "left",
                margin: [0, 2, 20, 0],                
                width: "95%",
              },
            ],
          },
          {
            text: "Teléfono: " + element.customer.Phone,
            fontSize: 30,
            alignment: "center",
            margin: [0, 5, 20, 0],
          }
        )
      : content.push(
          {
            text: element.billCode,
            fontSize: 90,
            bold: true,
            alignment: "center",
          },
          {
            columns: [
              {
                text: element.province,
                fontSize: 80,
                alignment: "center",
                margin: [0, 2, 70, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: element.municipality,
                fontSize: 60,
                alignment: "center",
                margin: [0, 2, 10, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: "Destinatario: " + element.customer.Name,
                fontSize: 40,
                alignment: "left",
                margin: [0, 0, 20, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: element.customer.Address,
                fontSize: 25,
                alignment: "left",
                margin: [0, 0, 20, 0],                
                width: "95%",
              },
            ],
          },
          {
            text: "Teléfono: " + element.customer.Phone,
            fontSize: 30,
            alignment: "center",
            margin: [0, 5, 20, 0],
          }
        );

    const documentDefinition = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          columns: [content],          
        },
      ],
    };
    this.spinner.hide();
    pdfMake.createPdf(documentDefinition).open();
  }

  generateColumns(content) {
    let array = [];
    for (let i = 0; i < content.length; i++) {
      array.push(content.slice(i, i + 1));
    }
    return array;
  }

  generateShippingLabelsPDF(shippingId) {
    this.spinner.show();
    const cardWidth = 15 * 72;
    const cardHeight = 10 * 72;
    const margin = 15;

    const content = [];

    const shipping = this.shippingBillsShow.find((x) => x.id === shippingId);
    if (shipping) {
      let array: any = shipping.bills;

      for (let i = 0; i < array.filteredData.length; i++) {
        let letter = "R";
        if (array.filteredData[i]?.shipingType === 3)
          letter = "M";
        else if (array.filteredData[i]?.shipingType === 2)
          letter = '';
        const showLetter = array.filteredData[i].shipingType == 3 || array.filteredData[i].shipingType == 1;
        const boxWidth = 70;
        const boxHeight = 70;
        const fontSize = 70;

        // Estimate text size (approximate for single character)
        const estimatedTextWidth = fontSize * 0.8;
        const estimatedTextHeight = fontSize * 0.8;

        const textX = ((boxWidth - estimatedTextWidth) / 2) + 1;
        const textY = ((boxHeight - estimatedTextHeight) / 2) + 1;
        content.push(
          {
            columns: [
              ...(showLetter ? [{
                width: "auto",
                stack: [
                  {
                    canvas: [
                      {
                        type: "rect",
                        x: 0,
                        y: 0,
                        w: boxWidth,
                        h: boxHeight,
                        r: 20,
                        color: "black",
                      },
                    ],
                  },
                  {
                    text: letter,
                    color: "white",
                    bold: true,
                    fontSize: array.filteredData[i]?.shipingType === 3 ? 60 : 70,
                    absolutePosition: { x: array.filteredData[i]?.shipingType === 1 ? 30 : 28, y: array.filteredData[i]?.shipingType === 1 ? 25 : 30 } // Tweaked to center visually
                  },
                ],
                margin: [0, 10, 10, 0],
              }] : []),
            
              {
                text: array.filteredData[i].billCode,
                fontSize: 90,
                bold: true,
                alignment: "right",
                margin: [10, 10, 0, 10],
              },
              {
                qr: array.filteredData[i].billCode,
                fit: 100,
                fontSize: 20,
                bold: true,
                alignment: "left",
                margin: [15, 10, 65, 10],
              },
            ],
          },
          {
            columns: [
              {
                text: array.filteredData[i].province,
                fontSize: 80,
                alignment: "center",
                margin: [0, 2, 70, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: array.filteredData[i].municipality,
                fontSize: 60,
                alignment: "center",
                margin: [0, 2, 10, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: "Destinatario: " + array.filteredData[i].customer.Name,
                fontSize: 40,
                alignment: "left",
                margin: [0, 2, 20, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: array.filteredData[i].customer.Address,
                fontSize: 25,
                alignment: "left",
                margin: [0, 2, 20, 0],
                width: "95%",
              },
            ],
          },
          {
            text: "Teléfono: " + array.filteredData[i].customer.Phone,
            fontSize: 30,
            alignment: "center",
            margin: [0, 5, 20, 0],
            pageBreak: "after",
          }
        );
      }
    }

    const documentDefinition = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [20, 20, 20, 20],
      content: [
        {
          columns: [this.generateColumns(content)],
          columnGap: margin,
        },
      ],
    };
    this.spinner.hide();
    pdfMake.createPdf(documentDefinition).open();
    //pdfMake.createPdf(documentDefinition).download('document.pdf');
  }

  ModelBillSummaryParse(array: BillSummaryShipmentDto[]): BillSummaryShow[] {
    return array.map(({ senderModel, customerModel, ...rest }) => ({
      ...rest,
      customer: JSON.parse(customerModel),
    }));
  }

  transformResponse(shippingBills: Array<ShippingModelWithBillModel>) {
    this.shippingBillsShow = [];
    shippingBills.forEach((shipping) => {
      if (
        shipping.bills &&
        Array.isArray(shipping.bills) &&
        shipping.bills.length
      ) {
        let bills: BillSummaryShow[] = [];
        bills = this.ModelBillSummaryParse(shipping.bills);

        this.shippingBillsShow.push({
          ...shipping,
          shippingTypeName: this.shippingTypes.find(
            (b) => b.id === shipping.shippingType
          )?.name,
          bills: new MatTableDataSource(bills),
        });
      } else {
        this.shippingBillsShow.push({
          ...shipping,
          shippingTypeName: this.shippingTypes.find(
            (b) => b.id === shipping.shippingType
          )?.name,
          bills: new MatTableDataSource([]),
        });
      }
    });
    this.dataSource = new MatTableDataSource(this.shippingBillsShow);
    this.dataSource.sort = this.sort;
    //this.dataSource.paginator = this.paginator;
    //this.dataSource.filterPredicate = this.filterByShipping();
    this.cd.detectChanges();
  }

  clean(): void {
    //this.searchFrm.controls["text"].setValue("");
    this.dataSource.filter = "";
    //this.showSearch = false;
  }

  filterByShipping() {
    let filterFunction = (data: ShippingShow, filter: string): boolean => {
      if (filter) {
        if (
          data.code === filter ||
          data.description === filter ||
          data.shippingTypeName === filter
        )
          return true;
        /*for (let i = 0; i < data.service!.workers!.length; i++) {
              if (subjects[i].indexOf(filter) != -1) {
                return true;
              }
            }*/
        return false;
      } else {
        return true;
      }
    };
    return filterFunction;
  }

  clearInputFilter(){
    this.searchFrm.get('text').setValue('');
    /*const params: SearchShipmentRQ = {
      
    };

    this.spinner.show();
    this.shippingService
      .apiShippingListWithBillsGet(params)
      .subscribe((response) => {
        //this.allShippings = this.shippings = this.ModelParse(response.list);
        this.totalRecords = response.totalRecords;
        this.transformResponse(response.list);
        this.searchFrm.get('text').setValue('');
        this.spinner.hide();
      });*/
  }

  applyFilter(filterValue: any) {    
    //const filterValue = (event.target as HTMLInputElement).value;     
    const params: SearchShipmentRQ = {
      clave: filterValue.text.trim().toLowerCase(),
    };
    this.spinner.show();
    this.shippingService
      .apiShippingListWithBillsGet(params)
      .subscribe((response) => {
        //this.allShippings = this.shippings = this.ModelParse(response.list);
        this.totalRecords = response.totalRecords;
        this.transformResponse(response.list);
        this.spinner.hide();
      });
    //this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  toggleRow(element: ShippingShow) {
    element.bills &&
    (element.bills as MatTableDataSource<BillSummaryShow>).data?.length
      ? (this.expandedElement =
          this.expandedElement === element ? null : element)
      : null;

    this.cd.detectChanges();
    this.innerTables.forEach(
      (table, index) =>
        ((table.dataSource as MatTableDataSource<BillSummaryShow>).sort =
          this.innerSort.toArray()[index])
    );
  }

  toggleSubRow(element: BillSummaryShow) {
    /*element.blocks && (element.blocks as MatTableDataSource<Block>).data.length
      ? (this.expandedSubElement =
          this.expandedSubElement === element ? null : element)
      : null;

    this.cd.detectChanges();
    this.subTables.forEach(
      (table, index) =>
        ((table.dataSource as MatTableDataSource<Block>).sort =
          this.subSort.toArray()[index])
    );*/
  }

  /*applyFilter(filterValue: string) {
    console.log(filterValue)
    this.innerTables.forEach(
      (table, index) =>
        ((table.dataSource as MatTableDataSource<BillSummaryShow>).filter = filterValue
          .trim()
          .toLowerCase())
    );
  }*/

  async FetchModels() {
    /*this.spinner.show();
    const request: ShippingListRQ = {      
    }

    this.shippingService.apiShippingListGet(request).subscribe(response => {      
      this.allShippings = this.shippings = this.ModelParse(response.list);      
      this.spinner.hide();
    });*/
    this.searching = true;
    this.spinner.show();
    const request: SearchShipmentRQ = {
      pageSize: 5,
      pageNumber: 1,
    };

    await this.shippingService
      .apiShippingListWithBillsGet(request)
      .toPromise()
      .then((response) => {
        //this.allShippings = this.shippings = this.ModelParse(response.list);
        //console.log(response)
        this.totalRecords = response.totalRecords;

        this.transformResponse(response.list);
        this.searching = false;
        //this.UpdateTotal(response.totalRecords);
        //console.log(this.totalRecords);
        //console.log(response);
        this.spinner.hide();
      });
    //console.log(this.totalRecords);
  }

  UpdateTotal(row: number) {
    this.totalRecords = row;
  }

  GetCodeById(id: number) {
    const bill = this.shippingBillsShow.find((b) => b.id === id);
    return bill.code;
  }

  LoadOrders(shipmentId: number) {}

  checkIsAdmin() {
    this.isAdmin = this._authenticationService.isAdministrator;
  }

  ModelParse(array: ShippingListModel[]): ShippingListModel[] {
    return array.map(({ shippingTypeName, shippingType, ...rest }) => ({
      shippingTypeName: this.shippingTypes.find((b) => b.id === shippingType)
        .name,
      ...rest,
      shippingType: shippingType,
    }));
  }

  FilterUpdate(event) {
    const keys = Object.keys(this.allShippings[0]);

    if (event && event !== "") {
      this.shippings = this.allShippings.filter((item) => {
        // iterate through each row's column data
        for (let i = 0; i < 6; i++) {
          // check for a match
          if (
            (item[keys[i]] &&
              item[keys[i]]
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .indexOf(
                  event
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toLowerCase()
                    .trim()
                ) !== -1) ||
            !event.toLowerCase()
          ) {
            // found match, return true to add to result set
            return true;
          }
        }
      });

      //this.shippings = this.allShippings.filter(x => x.code.toLowerCase().indexOf(event.toLowerCase()) > -1);
    } else {
      this.shippings = this.allShippings;
    }
  }

  ShowDelete(shippingId: number) {
    return this.shippingBillsShow.find((x) => x.id === shippingId)?.isActive;
  }

  OpenModalSearch() {
    const modalRef = this.modalService.open(SearchShipmentsComponent, {
      windowClass: "modal-dialog-example",
      size: "sm",
    });
    modalRef.result.then((result) => {
      if (result?.filter) {
        const params = result as SearchShipmentRQ;
        this.spinner.show();

        let search: SearchShipmentRQ = {
          clave: result.filter.clave,
          desde: result.filter.desde,
          envios: result.filter.envios,
          estadoFactura: result.filter.estadoFactura,
          hasta: result.filter.hasta,
          municipio: result.filter.municipio,
          provincia: result.filter.provincia,
          tipoEnvio: result.filter.tipoEnvio,
          vuelos: result.filter.vuelos,
        };

        this.filter = search;

        this.shippingService
          .apiShippingListWithBillsGet(search)
          .subscribe((response) => {
            //this.allShippings = this.shippings = this.ModelParse(response.list);
            this.totalRecords = response.totalRecords;
            this.transformResponse(response.list);
            this.spinner.hide();
          });
      }
    });
  }

  OpenCreateModal(shippingId?: number) {
    const modalRef = this.modalService.open(CreateShippingModalComponent, {
      windowClass: "modal",
    });
    if (shippingId) {
      const shipping = this.shippingBillsShow.find((x) => x.id === shippingId);
      modalRef.componentInstance.shipping = shipping;
    }

    modalRef.result.then(async (result) => {      
      if (result && !result.id) {
        const params: AddShippingRQ = result;        
        this.shippingService.apiShippingAddPost(params).subscribe(
          (response) => {
            Swal.fire({
              title: "Envío Creado.",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            setTimeout(() => {          
              this.FetchModels();
              }, 2000);            
          },
          (error) => {
            Swal.fire({
              title: "Error al crear envío. " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          }
        );
      } else if (result && result.id) {
        const params: UpdateShippingRQ = {
          code: result.code,
          createAt: result.createAt,
          description: result.description,
          id: result.id,
          shippingType: result.shippingType,
        };

        this.shippingService.apiShippingUpdatePost(params).subscribe(
          (response) => {
            Swal.fire({
              title: "Envío Actualizado.",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            setTimeout(() => {          
              this.FetchModels();
              }, 2000);              
          },
          (error) => {
            Swal.fire({
              title: "Error al actualizar el envío. " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          }
        );
      }
    });
  }

  exportList(): ShippingListExportModel[] {
    let exportflights: ShippingListExportModel[] = [];
    if (this.shippingBillsShow)
      this.shippingBillsShow.forEach((row) => {
        let now: ShippingListExportModel = this.GetShippingToExport(row);
        exportflights.push(now);
      });
    return exportflights;
  }

  GetShippingToExport(row: ShippingShow) {
    let ret: ShippingListExportModel = {
      CODIGO: row.code,
      TIPO_ENVIO: this.shippingTypes.find((b) => b.id === row.shippingType)
        .name,
      DESCRIPCION: row.description,
      FECHA_CREACION: this.datePipe.transform(row.createAt, "MMM/dd/yyyy"),
      COSTO: this.currencyPipe.transform(row.totalCost),
      ACTIVO: row.isActive,
    };
    return ret;
  }

  export() {
    const swal = Swal.fire({
      title: "Escoja la opción de exportar datos.",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "Excel",
      cancelButtonText: "PDF",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.exportexcel();
      } else if (
        result.isDismissed &&
        result.dismiss == Swal.DismissReason.cancel
      ) {
        this.generatePDF();
      }
    });
  }

  exportexcel(): void {
    /* pass here the data source */
    let exportobj: any = this.exportList();

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportobj);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    let newDate: Date = new Date();
    const fecha = this.datePipe.transform(newDate, "MMM/dd/yyyy");

    let fileName: any = `envios_${fecha}.xlsx`;

    /* save to file */
    XLSX.writeFile(wb, fileName);
  }

  generatePDF() {
    this.spinner.show();
    const contenido: string[][] = [];
    contenido.push([
      "#",
      "CODIGO",
      "TIPO ENVIO",
      "DESCRIPCION",
      "COSTO",
      "FECHA CREACION",
      "ESTADO",
    ]);

    this.shippingBillsShow.forEach((b, index) => {
      contenido.push([
        (index + 1).toString(),
        b.code,
        b.shippingTypeName,
        b.description,
        this.currencyPipe.transform(b.totalCost),
        this.datePipe.transform(b.createAt, "MMM/dd/yyyy"),
        b.isActive ? "Abierto" : "Cerrado",
      ]);
    });
    const totalColumn: any[] = [];

    const documentDefinition = {
      pageOrientation: "landscape",
      pageSize: "LETTER",
      content: [
        {
          columns: [
            { text: "Reporte Envíos: ", style: ["title"], margin: [0, 10] },
          ],
        },
        {
          text: "Fecha: " + this.datePipe.transform(new Date(), "MMM/dd/yyyy"),
          style: ["subtitle"],
          margin: [0, 0],
        },
        {
          layout: "lightHorizontalLines",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto"],
            body: contenido,
          },
        },
      ],
      styles: {
        title: {
          fontSize: 22,
          bold: true,
          alignment: "left",
        },
        title2: {
          fontSize: 12,
          bold: true,
          alignment: "right",
        },
        subtitle: {
          fontSize: 14,
          alignment: "left",
        },
        footer: {
          fontSize: 8,
          alignment: "right",
        },
      },
    };
    pdfMake.createPdf(documentDefinition).open();
    this.spinner.hide();
  }

  OpenExpensesModal(shippingId: number) {
    const modalRef = this.modalService.open(ShippingExpensesModalComponent, {
      windowClass: "modal",
      size: "lg",
    });
    modalRef.componentInstance.shipping = this.shippingBillsShow.find(
      (x) => x.id === shippingId
    );
    modalRef.result.then((result) => {
      this.FetchModels();
    });
  }

  OpenFlightsModal(shippingId: number) {
    const modalRef = this.modalService.open(ShippingFlightModalComponent, {
      windowClass: "modal",
      size: "lg",
    });
    modalRef.componentInstance.shipping = this.shippingBillsShow.find(
      (x) => x.id === shippingId
    );
  }

  checkIfFlightHasFlights(shippingId: number) {
    return this.shippingBillsShow.find((x) => x.id === shippingId)?.hasFlights;
  }

  checkIfFlightHasBills(shippingId: number) {
    const shipping = this.shippingBillsShow.find((x) => x.id === shippingId);  
    if (shipping.shippingType != 1 && shipping.shippingType != 3) return false;
      let array: any = shipping.bills;
      if (array.filteredData.length > 0) return true;    
    return false;
  }

  Delete(shippingId: number) {
    if (this.checkIfFlightHasFlights(shippingId)) {
      if (this.isAdmin) {
        const swal = Swal.fire({
          title:
            "El envío tiene vuelos asociados y solo puede ser eliminado por un administrador. ¿Está seguro que desea eliminar el envío?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const param: DeleteShippingRQ = {
              id: shippingId,
              isAdmin: this.isAdmin,
            };
            this.shippingService.apiShippingDeletePost(param).subscribe(
              (response) => {
                Swal.fire({
                  title: "Envío Eliminado",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 2000,
                  position: "top-end",
                });

                setTimeout(() => {
                  this.FetchModels();
                }, 2000);
              },
              (error) => {
                Swal.fire({
                  title: error ?? "Error al eliminar el envío",
                  icon: "error",
                  showConfirmButton: false,
                  timer: 2000,
                  position: "top-end",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                });
              }
            );
          }
        });
      } else {
        Swal.fire({
          title:
            "El envío tiene vuelos asociados y solo puede ser eliminado por un administrador.",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      }
    } else {
      const swal = Swal.fire({
        title: "¿Está seguro que desea eliminar el envío?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-primary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const param: DeleteShippingRQ = {
            id: shippingId,
            isAdmin: this.isAdmin,
          };
          this.shippingService.apiShippingDeletePost(param).subscribe(
            (response) => {
              Swal.fire({
                title: "Envío Eliminado",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });

              setTimeout(() => {
                this.FetchModels();
              }, 2000);
              //this.FetchModels();
            },
            (error) => {
              Swal.fire({
                title: error ?? "Error al eliminar el envío",
                icon: "error",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            }
          );
        }
      });
    }
  }

  GetState(date: string) {
    //return new Date(date).getTime() === this.minDate;
    return true;
  }
}

export interface User {
  name: string;
  email: string;
  phone: string;
  addresses?: Address[] | MatTableDataSource<Address>;
}

export interface ShippingShow {
  id?: number;
  code?: string;
  shippingType?: number;
  shippingTypeName?: string;
  description?: string;
  totalCost?: number;
  createAt?: Date;    
  closeAt?: Date;
  isActive?: boolean;
  hasFlights?: boolean;
  bills?: BillSummaryShow[] | MatTableDataSource<BillSummaryShow>;
}

export interface BillSummaryShow {
  billId?: number;
  billCode?: string;
  serviceCode?: string;
  province?: string;
  municipality?: string;
  billPounds?: number;
  status?: string;
  billType?: number;
  stateCatalogId?: number;
  customer?: CustomerAssignLocalModel;
  address?: string;
  shipingType?: number;
}


export interface Address {
  street: string;
  zipCode: string;
  city: string;
  blocks?: Block[] | MatTableDataSource<Block>;
}

export interface Block {
  name: string;
  level: string;
  unitnumber: string;
}

export interface UserDataSource {
  name: string;
  email: string;
  phone: string;
  addresses?: MatTableDataSource<Address>;
}

const USERS: User[] = [
  {
    name: 'Mason',
    email: 'mason@test.com',
    phone: '9864785214',
    addresses: [
      {
        street: 'Street 1',
        zipCode: '78542',
        city: 'Kansas',
        blocks: [
          {
            name: 'Blk 11',
            level: 'Lvl 1',
            unitnumber: '01-01',
          },
          {
            name: 'Blk 22',
            level: 'Lvl 2',
            unitnumber: '02-01',
          },
        ],
      },
      {
        street: 'Street 2',
        zipCode: '78554',
        city: 'Texas',
        blocks: [
          {
            name: 'Blk 33',
            level: 'Lvl 3',
            unitnumber: '03-02',
          },
          {
            name: 'Blk 44',
            level: 'Lvl 4',
            unitnumber: '04-02',
          },
        ],
      },
    ],
  },
  {
    name: 'Jason',
    email: 'jason@test.com',
    phone: '7856452187',
    addresses: [
      {
        street: 'Street 5',
        zipCode: '23547',
        city: 'Utah',
      },
      {
        street: 'Street 5',
        zipCode: '23547',
        city: 'Ohio',
      },
    ],
  },
];
